/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import { Component, HostListener, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * Angular component that will house the modal to save caption in carousel.
 */
@Component({
  selector: 'bulb-image-carousel-caption-dialog',
  templateUrl: './image-carousel-caption-dialog.component.html',
  styleUrls: ['./image-carousel-caption-dialog.component.scss'],
  standalone: false,
})
export class ImageCarouselCaptionDialogComponent implements OnInit {
  /**
   * Contains caption text.
   */
  public bulbImageCarouselCaption: string;

  /**
   * Contains active slide index.
   */
  public activeImageCarouselSlideIndex: number;

  /**
   * Contains id of image carousel block.
   */
  bulbBlockId: string;

  /**
   * Contains the translated label of submit button.
   */
  submitButtonText: string;

  /**
   * Default Constructor.
   * @param config Dialog configuration.
   * @param dynamicDialogRef Reference to the open dialog.
   *
   */
  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {}

  ngOnInit(): void {
    this.bulbImageCarouselCaption = this.config.data.captionText;
    this.bulbBlockId = this.config.data.bulbBlockId;
    this.submitButtonText = this.config.data.dialogConfirmBtnText;
  }

  /**
   * Listen to the event for dispatching current active slide index of selected Carousel.
   */
  @HostListener('window:dispatchSlideIndex', ['$event'])
  onDispatchSlideIndex(event) {
    this.activeImageCarouselSlideIndex = event.detail.activeIndex;
    if (event.detail.activeIndex === -1) {
      this.activeImageCarouselSlideIndex = 0;
    }
  }

  /**
   * Method use for saving caption in carousel.
   */
  saveCaption() {
    const currentIndexEvent = new CustomEvent('currentSlideIndex', {
      detail: {
        blockId: this.bulbBlockId,
      },
    });
    window.dispatchEvent(currentIndexEvent);
    const openAssetLibraryEvent = new CustomEvent('changeCarouselCaption', {
      detail: {
        newCaption: this.bulbImageCarouselCaption,
        eventFiredFromEditor: true,
        blockId: this.bulbBlockId,
        imageIndex: this.activeImageCarouselSlideIndex,
      },
    });

    window.dispatchEvent(openAssetLibraryEvent);
    this.dynamicDialogRef.close();
  }
}
